// src/pages/CityTourPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import CitytourImage from './assets/CityTour.jpg'; // Import image

function CityTourPage() {
  return (
    <div className="tour-detail-page">
      <section className="hero-subpage city-tour-hero">
        <div className="hero-content">
          <h1>Ebamba's Cape Town City Tour</h1>
          <p>Explore the vibrant heart of the Mother City with expert local guides.</p>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container">
          <h2 className="text-center">Discover Cape Town's Soul</h2>
          <div className="content-intro">
            <img src={CitytourImage} alt="Cape Town City Tour" className="tour-main-image" />
            <p>Embark on an immersive journey through Cape Town's rich history, diverse culture, and bustling modern life. Our private city tour with Ebamba Travel & Tours is designed to showcase the best of this incredible destination, from its iconic landmarks to its hidden gems.</p>
            <p>From the colorful Bo-Kaap neighborhood to the historical Castle of Good Hope, you'll experience the unique blend of African, European, and Asian influences that define Cape Town. Your personal guide will provide fascinating insights, making every stop a memorable learning experience.</p>
          </div>

          <h3 className="text-center mt-5">What to Expect on Your City Tour</h3>
          <div className="expect-grid">
            <div className="expect-item">
              <i className="fas fa-landmark"></i>
              <h4>Historic Landmarks</h4>
              <p>Visit the Houses of Parliament, City Hall, and the District Six Museum (optional) for a deep dive into South African history.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-palette"></i>
              <h4>Bo-Kaap Charm</h4>
              <p>Wander through the vibrant streets of Bo-Kaap, famous for its brightly colored houses and unique Cape Malay culture.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-shop"></i>
              <h4>V&A Waterfront</h4>
              <p>Explore the bustling V&A Waterfront, a hub of shopping, dining, and entertainment, with stunning harbor views.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-utensils"></i>
              <h4>Culinary Delights</h4>
              <p>Discover local eateries and taste authentic Cape Town flavors, from street food to fine dining (lunch options available).</p>
            </div>
          </div>

          <h3 className="text-center mt-5">Hear From Our Happy Travelers</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"The Ebamba City Tour was phenomenal! Our guide was incredibly knowledgeable and passionate. We saw so much more than we ever could have on our own."</p>
              <span>– Jessica R. from USA</span>
            </div>
            <div className="testimonial-card">
              <p>"Absolutely loved the personalized experience. Exploring Bo-Kaap with a local perspective was truly special. Highly recommend Ebamba for an authentic city tour."</p>
              <span>– Marcus L. from UK</span>
            </div>
          </div>

          <div className="text-center mt-5">
            <Link to="/contact" className="btn btn-primary large-btn tour-btn">Book Your Cape Town City Tour</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CityTourPage;
